import { render } from "./UpnavbarComp.vue?vue&type=template&id=12412db8&scoped=true"
import script from "./UpnavbarComp.vue?vue&type=script&lang=js"
export * from "./UpnavbarComp.vue?vue&type=script&lang=js"

import "./UpnavbarComp.vue?vue&type=style&index=0&id=12412db8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12412db8"]])

export default __exports__